// import React from "react";
// import "./SobreNos.css";
// import { Target, Users, TrendingUp, Shield } from "lucide-react";

// const SobreNos = () => {
//   const features = [
//     {
//       icon: Target,
//       title: "Estratégia Focada",
//       description:
//         "Desenvolvemos estratégias personalizadas baseadas no perfil único da sua clínica e mercado de atuação.",
//     },
//     {
//       icon: Users,
//       title: "Equipe Especializada",
//       description:
//         "Consultores com experiência comprovada no setor de saúde e gestão de clínicas de alto padrão.",
//     },
//     {
//       icon: TrendingUp,
//       title: "Resultados Mensuráveis",
//       description:
//         "Acompanhamento de KPIs específicos com relatórios detalhados e metas claras de crescimento.",
//     },
//     {
//       icon: Shield,
//       title: "Confidencialidade",
//       description:
//         "Sigilo absoluto e proteção de dados com processos seguros e compliance total.",
//     },
//   ];

//   return (
//     <section id="quem-somos" className="about-section" data-aos="fade-in">
//       <div className="about-container">
//         <div className="about-grid">
//           <div className="about-content">
//             <div className="about-heading">
//               <h2 className="about-title">
//                 Especialistas em{" "}
//                 <span className="highlight">transformação</span> de clínicas
//               </h2>
//               <p className="about-subtitle">
//                 A Arcadian nasceu da necessidade de elevar o padrão da gestão em
//                 clínicas e consultórios médicos. Combinamos expertise em
//                 negócios com profundo conhecimento do setor de saúde.
//               </p>
//               <p className="about-subtext">
//                 Nossa missão é transformar clínicas em negócios sustentáveis e
//                 altamente rentáveis, sem comprometer a qualidade do atendimento.
//                 Acreditamos que excelência médica e excelência empresarial
//                 caminham juntas.
//               </p>
//             </div>
//           </div>

//           <div className="about-features">
//             {features.map((feature, index) => (
//               <div className="feature-card" key={index}>
//                 <div className="feature-icon-wrapper">
//                   <feature.icon className="feature-icon" />
//                 </div>
//                 <div>
//                   <h4 className="feature-title">{feature.title}</h4>
//                   <p className="feature-description">{feature.description}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SobreNos;

import React from "react";
import "./SobreNos.css";
import { Target, Users, TrendingUp, Brain } from "lucide-react";

const SobreNos = () => {
  const features = [
    {
      icon: Target,
      title: "CRM de Alta Performance",
      description:
        "Implementamos um CRM avançado e personalizável. Treinamos sua equipe e criamos uma cultura de acompanhamento diário que transforma leads em pacientes — e pacientes em crescimento.",
    },
    {
      icon: Users,
      title: "Autoridade Digital Estratégica",
      description:
        "Nada de conteúdo genérico. Atuamos com editor, roteirista e estrategista para posicionar sua clínica como referência nas redes, usando influência real e storytelling alinhado ao seu público.",
    },
    {
      icon: TrendingUp,
      title: "Cultura de Gestão Comercial",
      description:
        "Treinamos o tomador de decisão e o time comercial para operar com metas claras, rituais semanais e foco total em performance. Medimos tudo — porque o que não é medido, não cresce.",
    },
    {
      icon: Brain,
      title: "Inteligência Estratégica de Crescimento",
      description:
        "Automatizamos sua operação comercial com insights, dados e projeções. Sua clínica se transforma em uma máquina de crescimento previsível e escalável.",
    },
  ];

  return (
    <section id="quem-somos" className="about-section" data-aos="fade-in">
      <div className="about-container">
        <div className="about-grid">
          <div className="about-content">
            <span className="cases-label">Quem Somos</span>
            <div className="about-heading">
              <h2 className="about-title">
                <span style={{fontSize: "1.9rem"}}>Muito além de uma agência.</span>
                <br />
                <span className="highlight">Somos o braço estratégico</span> da
                sua clínica.
              </h2>
              <p className="about-subtitle">
                A Arcadian transforma operações comerciais de clínicas de saúde
                estética em máquinas de crescimento previsível e escalável.
              </p>
              <p className="about-subtext">
                Nosso trabalho une tecnologia, posicionamento e cultura de
                performance. Acreditamos que excelência médica e excelência
                comercial caminham juntas — e preparam o terreno para o
                crescimento sustentável.
              </p>
            </div>
          </div>

          <div className="about-features">
            {features.map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon-wrapper">
                  <feature.icon className="feature-icon" />
                </div>
                <div>
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreNos;
